export class Filter {
  path: string
  operator?: string | null
  value?: string | null
  valueList?: string[] | null

  constructor(path: string, operator: string | null, value: string | string[]) {
    this.path = path
    if (operator) {
      this.operator = operator
    }
    if (!Array.isArray(value)) {
      this.value = value
    } else {
      this.valueList = value
    }
  }
}

export class Sort {
  path: string
  descending: boolean | undefined

  constructor(path: string, descending = false) {
    this.path = path
    this.descending = descending ? descending : undefined
  }
}

export class RestQuery {
  limit: number
  offset: number
  // the C# has a singular name, filter, for the array of filters
  filter: Filter[]
  sort: Sort[]

  constructor(limit: number, offset: number) {
    this.limit = limit
    this.offset = offset
    this.filter = []
    this.sort = []
  }

  addFilter(filter: Filter) {
    this.filter.push(filter)
  }

  addSort(sort: Sort) {
    this.sort.push(sort)
  }

  // do not call encodeURIComponent on the result
  toEncodedQueryString(prefix: string): string {
    if (0 < prefix.length && !prefix.endsWith('.')) prefix = `${prefix}.`
    const filterQuery = this.filter
      .map((aFilter) => `&${prefix}Filter=${encodeURIComponent(JSON.stringify(aFilter))}`)
      .join()

    const sortQuery = this.sort.map((aSort) => `&${prefix}Sort=${encodeURIComponent(JSON.stringify(aSort))}`).join()
    return `${prefix}Limit=${this.limit}&${prefix}Offset=${this.offset}` + filterQuery + sortQuery

    // return `${prefix}Limit=${this.limit}&${prefix}Offset=${this.offset}` + filterQuery
  }
}

export class CSRestQuery {
  limit: number
  offset: number
  // the C# has a singular name, filter, for the array of filters
  filter: Filter[]
  sort: Sort[]

  constructor(limit: number, offset: number) {
    this.limit = limit
    this.offset = offset
    this.filter = []
    this.sort = []
  }

  addFilter(filter: Filter) {
    this.filter.push(filter)
  }
  addSort(sort: Sort) {
    this.sort.push(sort)
  }

  // do not call encodeURIComponent on the result
  toEncodedQueryString(): string {
    const filterQuery = this.filter.map((aFilter) => `&Filter=${encodeURIComponent(JSON.stringify(aFilter))}`).join()
    const sortQuery = this.sort.map((aSort) => `&Sort=${encodeURIComponent(JSON.stringify(aSort))}`).join()
    return `Limit=${this.limit}&Offset=${this.offset}` + filterQuery + sortQuery.replace(',', '')
  }
}

export class CSCreateQuery {
  constructor(userQuery: CSRestQuery | null) {
    this.oaiUserQuery = userQuery
  }

  oaiUserQuery: CSRestQuery | null

  toEncodedQueryString(): string {
    let query = ''

    if (this.oaiUserQuery) {
      if (0 < query.length) query += '&'
      query += this.oaiUserQuery.toEncodedQueryString()
    }
    if (0 < query.length) query = '?' + query
    return query
  }
}

export class CppuMenageQuery {
  constructor(userQuery: RestQuery | null) {
    this.oaiUserQuery = userQuery
  }

  oaiUserQuery: RestQuery | null

  toEncodedQueryString(): string {
    let query = ''
    if (this.oaiUserQuery) {
      if (0 < query.length) query += '&'
      query += this.oaiUserQuery.toEncodedQueryString('OaiUserQuery')
    }
    if (0 < query.length) query = '?' + query

    return query
  }
}
